module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.d0d27370.ttf";